<script setup>
import { defineProps, defineEmits, computed} from "vue";
import UtilMoney from "@/utils/UtilMoney";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "dado",
    "item",
]);

const emits = defineEmits([
    "update:alteraItem",
]);

//==================================================================//
//========================= Altera Item ============================//
//==================================================================//

const alteraItem = (update) =>{

    emits('update:alteraItem',update);

};

//==================================================================//
//======================= Ao Expandir Itens ========================//
//==================================================================//

const aoExpandirItens = (aberto = false)=>{

    alteraItem({
        aberto: !props?.item?.aberto,
    })

};

//==================================================================//
//===================== Mostra Expandir Itens ======================//
//==================================================================//

let mostraExpandirItens = computed(()=>{

    if(props?.item?.itensQuantidade <= 0){
        return false;
    }

    return true;

});

//==================================================================//
//==================== Mostra Campos Isentos =======================//
//==================================================================//

let mostraCamposIsentos = computed(()=>{

    if(props?.dado?.tipoVenda === 'Recap'){
        return true;
    }

    return false;

});

</script>

<template>

    <div
        class="c-table__row"
    >

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                <v-tooltip bottom>

                    <template v-slot:activator="{ on, attrs }">

                        <v-btn
                            v-show="mostraExpandirItens"
                            class="c-botao-expandir-item mx-2"
                            fab
                            dark
                            small
                            color="primary"
                            v-bind="attrs"
                            v-on="on"
                            @click="aoExpandirItens"
                        >

                            <v-icon
                                v-if="props?.item?.aberto == false"
                                dark
                            >
                                mdi-chevron-down
                            </v-icon>

                            <v-icon
                                v-else
                                dark
                            >
                                mdi-chevron-up
                            </v-icon>
                        
                        </v-btn>

                    </template>

                    <span>Visualizar os Itens do Item</span>

                </v-tooltip>

            </div>

        </div>

        <div class="c-table__cell c-table__cell">

            <div class="c-table__cell-content">

                <v-chip
                    color="#dedede"
                    label
                    dark
                >

                    <v-icon left color="#565656">
                        mdi-cube-outline
                    </v-icon>

                    <span
                        class="c-table__cell-content-text"
                    >

                        {{props?.item?.sequencia}}

                    </span>

                </v-chip>

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{props?.item?.tipoDeEquipamento?.descricao}}

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{props?.item?.tipoDeServico?.servicoCodigo}} - {{props?.item?.tipoDeServico?.servicoDescricao}}

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{props?.item?.ncm?.descricaoCompleta}}

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{props?.item?.descricao}}

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{props?.item?.dataPrazoEntregaFormatada}}

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{props?.item?.quantidade}}

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{UtilMoney.toR$BRL(props?.item?.precoUnitario)}}

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{UtilMoney.toR$BRL(props?.item?.precoTotal)}}

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{UtilMoney.toR$BRL(props?.item?.precoTotalLiquido)}}

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{props?.item?.porcentagemIPI}}%

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{UtilMoney.toR$BRL(props?.item?.valorIPI)}}

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{props?.item?.porcentagemBaseCalculoICMS}}%

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{UtilMoney.toR$BRL(props?.item?.baseCalculoICMS)}}

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{props?.item?.porcentagemICMS}}%

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{UtilMoney.toR$BRL(props?.item?.valorICMS)}}

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                <span v-show="!mostraCamposIsentos">
                    {{props?.item?.porcentagemBaseCalculoPIS}}%
                </span>

                <span v-show="mostraCamposIsentos">
                    Isento
                </span>

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                <span v-show="!mostraCamposIsentos">
                    {{UtilMoney.toR$BRL(props?.item?.baseCalculoPIS)}}
                </span>

                <span v-show="mostraCamposIsentos">
                    Isento
                </span>

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                <span v-show="!mostraCamposIsentos">
                    {{props?.item?.porcentagemPIS}}%
                </span>

                <span v-show="mostraCamposIsentos">
                    Isento
                </span>

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                <span v-show="!mostraCamposIsentos">
                    {{UtilMoney.toR$BRL(props?.item?.valorPIS)}}
                </span>

                <span v-show="mostraCamposIsentos">
                    Isento
                </span>

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                <span v-show="!mostraCamposIsentos">
                    {{props?.item?.porcentagemBaseCalculoCOFINS}}%
                </span>

                <span v-show="mostraCamposIsentos">
                    Isento
                </span>

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                <span v-show="!mostraCamposIsentos">
                    {{UtilMoney.toR$BRL(props?.item?.baseCalculoCOFINS)}}
                </span>

                <span v-show="mostraCamposIsentos">
                    Isento
                </span>

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                <span v-show="!mostraCamposIsentos">
                    {{props?.item?.porcentagemCOFINS}}%
                </span>

                <span v-show="mostraCamposIsentos">
                    Isento
                </span>

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                <span v-show="!mostraCamposIsentos">
                    {{UtilMoney.toR$BRL(props?.item?.valorCOFINS)}}
                </span>

                <span v-show="mostraCamposIsentos">
                    Isento
                </span>

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                <span v-show="!mostraCamposIsentos">
                    {{props?.item?.porcentagemBaseCalculoISS}}%
                </span>

                <span v-show="mostraCamposIsentos">
                    Isento
                </span>

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                <span v-show="!mostraCamposIsentos">
                    {{UtilMoney.toR$BRL(props?.item?.baseCalculoISS)}}
                </span>

                <span v-show="mostraCamposIsentos">
                    Isento
                </span>

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{props?.item?.porcentagemISS}}%

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{UtilMoney.toR$BRL(props?.item?.valorISS)}}

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{props?.item?.porcentagemBaseCalculoIRRF}}%

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                <span v-show="!mostraCamposIsentos">
                    {{UtilMoney.toR$BRL(props?.item?.baseCalculoIRRF)}}
                </span>

                <span v-show="mostraCamposIsentos">
                    Isento
                </span>

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{props?.item?.porcentagemIRRF}}%

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{UtilMoney.toR$BRL(props?.item?.valorIRRF)}}

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{props?.item?.porcentagemBaseCalculoCSLL}}%

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                <span v-show="!mostraCamposIsentos">
                    {{UtilMoney.toR$BRL(props?.item?.baseCalculoCSLL)}}
                </span>

                <span v-show="mostraCamposIsentos">
                    Isento
                </span>

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{props?.item?.porcentagemCSLL}}%

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{UtilMoney.toR$BRL(props?.item?.valorCSLL)}}

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{props?.item?.porcentagemBaseCalculoINSS}}%

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                <span v-show="!mostraCamposIsentos">
                    {{UtilMoney.toR$BRL(props?.item?.baseCalculoINSS)}}
                </span>

                <span v-show="mostraCamposIsentos">
                    Isento
                </span>

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{props?.item?.porcentagemINSS}}%

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{UtilMoney.toR$BRL(props?.item?.valorINSS)}}

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content"></div>

        </div>

    </div>

</template>

<style scoped>


.c-table__row{
    display: grid;
    grid-template-columns: subgrid;
    grid-column: 1 / -1;
    border-bottom: thin solid rgba(0, 0, 0, 0.12);
    font-size: 0.875rem;
}

.c-table__row:hover{
    background-color: #eeeeee;
}

.c-table__cell{
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 13px 16px;
}

.c-table__cell-content-text{
    color: #565656;
    font-weight: 600;
}

.c-controles{
    display: flex;
    align-items: center;
    gap: 20px;
}

.c-checkbox >>> .v-icon{
    font-size: 26px;
}

.c-checkbox >>> .v-input--selection-controls__input{
    margin: 0px;
}

.c-checkbox.v-input--is-label-active >>> .v-input--selection-controls__ripple{
    color: #1976d2 !important;
    caret-color: #1976d2 !important;
}

.c-checkbox.v-input--is-label-active >>> .v-icon{
    color: #1976d2 !important;
    caret-color: #1976d2 !important;
}

.theme--dark.v-btn.v-btn--disabled.v-btn--has-bg.c-botao-expandir-pagamentos{
    background: #3F51B5 !important;
    border-color: #3F51B5 !important;
}

</style>


